var exports = {
  "kL": "ChannelPinsPopout.module__container___TDBDUX",
  "wx": "ChannelPinsPopout.module__header___TDBDUX",
  "rf": "ChannelPinsPopout.module__body___TDBDUX",
  "DD": "ChannelPinsPopout.module__title___TDBDUX",
  "J3": "ChannelPinsPopout.module__iconLarge___TDBDUX",
};

module.exports = exports;
